<template>
  <div
    v-if="user && user.role"
    ref="sidebarMenuRef"
    class="panelGeneral d-flex flex-column"
    id="sidebarMenu"
    :class="[
      'panelGeneral d-flex flex-column',
      { open: props.isOpen, dragging: isDragging },
    ]"
    :style="dragStyle"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
  >
    <div v-if="isMobile" class="logo-container">
      <!-- <ThemedIcon name="LuqueLogoMuni" class="imgLuque" /> -->
      <ThemedIcon class="logo-gob360-mobile" name="LogoGob360" />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        class="arrow-close"
        :class="{ rotated: props.isOpen }"
        @click="toggleSidebar"
      >
        <g clip-path="url(#clip0_10541_33648)">
          <path
            d="M14.3082 20C14.1985 20.0006 14.0898 19.9796 13.9883 19.9381C13.8867 19.8967 13.7944 19.8356 13.7165 19.7583L6.9082 12.95C6.52017 12.5629 6.21231 12.1031 6.00226 11.5969C5.79221 11.0907 5.68408 10.5481 5.68408 9.99999C5.68408 9.45193 5.79221 8.90925 6.00226 8.40304C6.21231 7.89683 6.52017 7.43704 6.9082 7.04999L13.7165 0.241658C13.7942 0.16396 13.8865 0.102326 13.988 0.0602753C14.0895 0.018225 14.1983 -0.00341797 14.3082 -0.00341797C14.4181 -0.00341797 14.5269 0.018225 14.6284 0.0602753C14.7299 0.102326 14.8222 0.16396 14.8999 0.241658C14.9776 0.319357 15.0392 0.411599 15.0812 0.513117C15.1233 0.614636 15.1449 0.723442 15.1449 0.833325C15.1449 0.943208 15.1233 1.05201 15.0812 1.15353C15.0392 1.25505 14.9776 1.34729 14.8999 1.42499L8.09153 8.23332C7.62336 8.70208 7.3604 9.33749 7.3604 9.99999C7.3604 10.6625 7.62336 11.2979 8.09153 11.7667L14.8999 18.575C14.978 18.6525 15.04 18.7446 15.0823 18.8462C15.1246 18.9477 15.1464 19.0566 15.1464 19.1667C15.1464 19.2767 15.1246 19.3856 15.0823 19.4871C15.04 19.5887 14.978 19.6809 14.8999 19.7583C14.822 19.8356 14.7297 19.8967 14.6281 19.9381C14.5266 19.9796 14.4179 20.0006 14.3082 20Z"
            fill="var(--text-primary)"
          />
        </g>
        <defs>
          <clipPath id="clip0_10541_33648">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div v-else>
      <router-link to="/home-agentes">
        <ThemedIcon name="LuqueLogoMuni" class="imgLuque" />
      </router-link>
    </div>

    <div class="navScrollable">
      <div class="NavMuni d-flex flex-column gap-3">
        <div
          v-for="route in filteredMunicipalRoutes"
          :key="route.name"
          class="bn3 d-flex align-items-center"
          active-class="link-activo"
        >
          <router-link
            :to="{ name: route.name }"
            @click="emit('close')"
            class="d-flex align-items-center w-100 gap"
            active-class="link-activo"
          >
            <img
              :src="
                getIconPath(
                  theme === 'dark' ? route.meta.iconDark : route.meta.iconLight,
                )
              "
              class="iconos"
            />
            <h2 class="h2-defaultMuni">{{ route.meta.title }}</h2>

            <div
              v-if="
                route.meta.badgeResolver &&
                counters[route.meta.badgeResolver] > 0
              "
              class="image-container"
            >
              <img src="@/assets/images/LuqueCounter.svg" />
              <span class="turnos-value">
                {{ counters[route.meta.badgeResolver] }}
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="isMobile" class="actions-container">
      <ThemedIcon class="action" @click="toggleTheme" name="themeMobile" />
      <!-- <ThemedIcon class="action" @click="openNotifications" name="IconNoti" /> -->
      <ThemedIcon class="action" @click="openCloseSesion" name="IconOff" />
    </div>
  </div>

  <ModalManager ref="modalManagerRef" />
</template>

<script setup>
import { computed, onMounted, ref, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { navBarRoutes } from "@/router/router-utils";
import ModalManager from "@/components/Utils/Modales/ModalManager.vue";
// import NotificacionesPanel from "./NotificacionesPanel.vue";
import ModalCerrarSesion from "../Modals/ModalCerrarSesion.vue";
import { useSidebarBadges } from "@/services/helpers/useSidaBarBadges";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";
import { toggleTheme } from "@/services/helpers/themeHelper";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

const theme = ref("light");

onMounted(() => {
  theme.value = document.documentElement.getAttribute("data-theme");

  window.addEventListener("theme-change", () => {
    theme.value = document.documentElement.getAttribute("data-theme");
  });
});

const store = useStore();
const sidebarMenuRef = ref(null);
const modalManagerRef = ref(null);

const route = useRoute();
const router = useRouter();

const windowWidth = ref(window.innerWidth);
const isMobile = computed(() => windowWidth.value <= 770);
const user = computed(() => store.state.user);
const filteredMunicipalRoutes = computed(() => navBarRoutes(isMobile.value));

const updateWidth = () => {
  windowWidth.value = window.innerWidth;

  if (
    isMobile.value &&
    route.meta &&
    route.meta.isMunicipal &&
    !route.meta.allowMobile
  ) {
    if (
      filteredMunicipalRoutes.value &&
      filteredMunicipalRoutes.value.length > 0
    ) {
      router.push({ name: filteredMunicipalRoutes.value[0].name });
    } else {
      router.push({ name: "login" });
    }
  }
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

const isDragging = ref(false);
const touchStartX = ref(0);
const touchCurrentX = ref(0);

const onTouchStart = (e) => {
  if (!isMobile.value || !props.isOpen) return;
  touchStartX.value = e.touches[0].clientX;
  touchCurrentX.value = e.touches[0].clientX;
  isDragging.value = true;
};

const onTouchMove = (e) => {
  if (!isDragging.value) return;
  touchCurrentX.value = e.touches[0].clientX;
};

const onTouchEnd = () => {
  if (!isDragging.value) return;
  isDragging.value = false;
  const deltaX = touchCurrentX.value - touchStartX.value;
  if (deltaX < -70) {
    store.dispatch("setSidebarState", false);
  }
};

const dragStyle = computed(() => {
  if (!isDragging.value || !isMobile.value) return {};
  const deltaX = touchCurrentX.value - touchStartX.value;
  if (props.isOpen && deltaX < 0) {
    return { transform: `translateX(${deltaX}px)`, transition: "none" };
  }
  return {};
});

const { counters } = useSidebarBadges();

const getIconPath = (iconName) => {
  try {
    return require(`@/assets/images/${iconName}`);
  } catch (e) {
    return "";
  }
};

const toggleSidebar = () => {
  store.dispatch("toggleSidebar");
};

const openFirstModal = (modal, modalProps) => {
  if (modalManagerRef.value) {
    modalManagerRef.value.openModal(modal, modalProps);
  }
};

// const openNotifications = () => {
//   openFirstModal(NotificacionesPanel, {
//     size: "auto",
//     scrollable: false,
//     position: "bottom",
//     draggable: true,
//     dragDismiss: {
//       enabled: true,
//       minThresholdPx: 72,
//       minVelocity: 0.45,
//     },
//   });
// };

const openCloseSesion = () => {
  openFirstModal(ModalCerrarSesion, {
    size: "auto",
    scrollable: false,
    showX: false,
    noClose: true,
  });
};
</script>

<style scoped>
a {
  color: var(--text-primary) !important;
}

.panelGeneral {
  position: fixed;
  height: 100dvh;
  background: var(--gray);
  width: 15.227vw;
  padding: 3.339dvh 2.196vw;
  z-index: 1;
  gap: 5.008dvh;
  transition:
    transform 0.3s ease-in-out,
    width 0.3s ease-in-out;
  transform: translateX(-100%);
}

.imgLuque {
  width: 9.59vw;
  height: 6.678dvh;
  transition:
    transform 0.25s ease,
    filter 0.25s ease;
}

.imgLuque:hover {
  transform: scale(1.05);
  filter: brightness(1.05);
}

.navScrollable {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
}

.NavMuni {
  justify-content: center;
  flex-shrink: 0;
}

.bn3 {
  text-align: center;
  height: 8.347dvh;
  padding: 1.669dvh 0.366vw;
  border-radius: 0.25rem;
  border-bottom: 1px solid var(--text-primary);
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.bn3:hover:not(:has(.router-link-exact-active)) {
  background: rgba(0, 195, 168, 0.12);
  box-shadow: inset 0 0 0 var(--color-success);
}

/* Estilos de los Badges */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.9vw;
  height: 4.007dvh;
  position: relative;
  margin-left: auto;
  /* Empuja el badge a la derecha */
}

.image-container img {
  width: 2.907vw;
  aspect-ratio: 1 / 1;
  /* height: 3.506dvh; */
}

.iconos {
  width: 2.196vw;
  height: 5.008dvh;
}

.turnos-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1;
  font-size: 14px;
  font-weight: bold;
  color: var(--blanco);
}

.gap {
  gap: 0.73vw;
}

.bn3:has(.router-link-exact-active) {
  background: rgba(0, 195, 168, 0.2);
}

@media (min-width: 1400px) {
  .iconos {
    width: 35px;
    height: 35px;
  }
}

.panelGeneral.open {
  transform: translateX(0);
}

@media (min-width: 769px) {
  .panelGeneral {
    transform: translateX(0);
  }
}

/* ------------------ MOBILE ------------------ */
@media (max-width: 768px) {
  .panelGeneral {
    width: fit-content;
    padding: 30px 16px;
  }

  .imgLuque {
    width: 36.3vw;
  }

  .logo-container {
    gap: 5.56vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-items: center;
  }

  .arrow-close {
    transition: transform 1s cubic-bezier(0.4, 0, 0.2, 1);
    width: 6.93vw;
    height: 3.18dvh;
  }

  .arrow-close.rotated {
    transform: rotate(180deg);
  }

  .iconos {
    width: 8.31vw;
  }

  .bn3 {
    padding: 10px 5px;
  }

  .actions-container {
    display: flex;
    gap: 5.56vw;
    justify-content: center;
    /* padding: 0 10.53vw 2.67dvh 10.53vw; */
  }

  .action {
    width: 11.11vw;
  }

  .image-container {
    width: 7.22vw;
  }

  .image-container img {
    width: 10vw;
  }
}
</style>
